import { useLayoutContext } from 'contexts/LayoutContext';
import { ListLpFeesCategory } from 'further-types/lp/lp-fee';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { useState } from 'react';
import downloadXlxs from 'utils/downloadXlxs';
import useVehicle from '../vehicle/useVehicle';

const DEFAULT_PAGINATION_SETTINGS = {
  rowsPerPage: 10,
  order: 'desc',
  orderBy: 'accrualDate',
} as const;

export default function useFeeManager() {
  const { selectedVehicleId } = useLayoutContext();
  const { vehicle } = useVehicle(selectedVehicleId);
  const exportFeesMutation = api.lpFee.exportFees.useMutation(
    useHandleTrpcMutation()({
      onSuccess: (data) => {
        const typedData = data as { file: string };
        downloadXlxs(typedData.file, `LP-Fees - ${vehicle?.vehicleName}`);
      },
      successMessage: 'Fees exported successfully.',
    }),
  );

  const [dueFeesPage, setDueFeesPage] = useState(1);
  const [futureFeesPage, setFutureFeesPage] = useState(1);
  const [approvedFeesPage, setApprovedFeesPage] = useState(1);

  const { data: dueUnapprovedFees } = api.lpFee.list.useQuery(
    {
      vehicleId: selectedVehicleId ?? '',
      feesCategory: ListLpFeesCategory.DueUnapprovedFees,
      page: dueFeesPage,
      ...DEFAULT_PAGINATION_SETTINGS,
    },
    {
      enabled: !!selectedVehicleId,
      suspense: true,
    },
  );

  const { data: futureUnapprovedFees } = api.lpFee.list.useQuery(
    {
      vehicleId: selectedVehicleId ?? '',
      feesCategory: ListLpFeesCategory.FutureUnapprovedFees,
      page: futureFeesPage,
      ...DEFAULT_PAGINATION_SETTINGS,
    },
    {
      enabled: !!selectedVehicleId,
      suspense: true,
    },
  );

  const { data: approvedFees } = api.lpFee.list.useQuery(
    {
      vehicleId: selectedVehicleId ?? '',
      feesCategory: ListLpFeesCategory.ApprovedFees,
      page: approvedFeesPage,
      ...DEFAULT_PAGINATION_SETTINGS,
    },
    {
      enabled: !!selectedVehicleId,
      suspense: true,
    },
  );

  return {
    dueUnapprovedFees,
    futureUnapprovedFees,
    approvedFees,
    dueFeesPage,
    futureFeesPage,
    approvedFeesPage,
    setDueFeesPage,
    setFutureFeesPage,
    setApprovedFeesPage,
    exportFeesMutation,
  };
}
